import { useMutateEntry } from '@utils/component-framework';
import { bringItemToFront } from './utils/bring-item-to-front.js';
import { getPageEntryById } from './utils/get-page-by-id.js';

function useMoveCloneEntryMutation(entryKey) {
  const mutater = useMutateEntry(entryKey);
  return args => mutater(entry => {
    const page = getPageEntryById(entry.data, args.pageId);
    const clone = page.clones.find(it => it.cloneId === args.cloneId);
    if (clone === undefined) {
      return entry;
    }
    clone.position = args.position;
    bringItemToFront(page, clone);
    return entry;
  });
}

export { useMoveCloneEntryMutation };
//# sourceMappingURL=clone.move.js.map
